import TargetLanguageCategory from './model';

export default TargetLanguageCategory;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/TargetLanguageCategories/index.js